import { MenuKeyLink, MenuKeyOption, MenuKeysMap } from './types';

export const getMenuKeys = (menuKeysMap: MenuKeysMap, pathname: MenuKeyLink): MenuKeyOption =>
  menuKeysMap[pathname] || {};
